import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export default function NewsroomColorSchemeRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.NewsroomColorScheme', {
		url: '/newsroom/colorscheme',
		controllerAs: 'vm',
		controller: NewsroomColorSchemeCtrl,
		templateUrl: '/ng/hub/Newsroom/ColorScheme/NewsroomColorSchemeCtrl.html?' + window.BUILD,
		resolve: {
			colorSchemes: ApiResourcify.endpoint('/newsrooms/color_schemes'),
		},
	});
}

class NewsroomColorSchemeCtrl {
	constructor(modal, Api, $stateParams, colorSchemes) {
		'ngInject';
		this.modal = modal;
		this.Api = Api;
		this.colorSchemes = colorSchemes;
		this.selectedSchemeId = $stateParams.selectedSchemeId;
	}

	createCustomScheme() {
		let modalOptions = {
			heading: 'Create Custom',
			height: 291,
			width: 625,
		};
		this.modal.state('hub.loggedin.NewsroomCustomColorScheme', modalOptions).then(newSchemeId => {
			// set to empty so that list will scroll to top before refreshing
			this.colorSchemes = [];
			this.Api.get('/newsrooms/color_schemes').then(schemes => {
				this.colorSchemes = schemes;
				this.selectedSchemeId = newSchemeId;
			});
		});
	}
}
